import React, { useState } from 'react';

import clsx from 'clsx';

import { useDevice } from '@bonnet/next/device';

import {
    Box,
    Button,
    Collapsible,
    Glyphicon,
    Image,
    Link,
    SubHeading,
} from 'reaxl';

function CollapsibleToggle({ collapsed, onExpand }) {
    return (
        <Button
            bsStyle="text"
            onClick={!collapsed ? onExpand : undefined}
        >
            {collapsed ? 'See Less' : 'See More'}
            <Glyphicon
                className="margin-left-2"
                glyph={collapsed ? 'menu-up' : 'menu-down'}
            />
        </Button>
    );
}

function Card({
    children,
    collapsible,
    handleClick,
    heading,
    id,
    image,
    link,
    linkLabel,
    showTile,
    summary,
    onExpand = () => { },
    ...rest
}) {
    const device = useDevice();

    const [showMoreContent, setShowMoreContent] = useState(false);

    const handleCollapsibleHeaderToggle = () => setShowMoreContent((prevState) => !prevState);

    if (!summary) {
        summary = children;
        children = null;
    }

    const mainContent = (
        <>
            <div>
                <SubHeading size={400}>
                    {heading}
                </SubHeading>
                {summary}
            </div>
            {/* Wrapping div required for alignment due to Image lazy load behavior */}
            {showTile && (
                <div
                    className="align-self-center"
                    key={`image-${id}`}
                >
                    {link ? (
                        <Link
                            href={link}
                            onClick={handleClick || undefined}
                            target="_blank"
                            rel="nofollow noopener"
                            aria-label={linkLabel || heading}
                        >
                            <Image
                                alt=""
                                src={image}
                                width={68}
                                height={38}
                            />
                        </Link>
                    ) : (
                        <Image
                            alt=""
                            aria-hidden="true"
                            src={image}
                            width={68}
                            height={68}
                        />
                    )}
                </div>
            )}
        </>
    );

    return (
        <Box
            key={id}
            data-cmp={`${id}Card`}
            className={clsx({ 'display-flex justify-content-between': !children })}
            {...rest}
        >
            {!children && mainContent}
            {!!children && (
                <>
                    <div className="display-flex justify-content-between">
                        {mainContent}
                    </div>
                    {collapsible && device?.is?.xs ? (
                        <Collapsible
                            onToggle={handleCollapsibleHeaderToggle}
                            toggleFooter={(
                                <CollapsibleToggle
                                    collapsed={showMoreContent}
                                    onExpand={onExpand}
                                />
                            )}
                        >
                            {children}
                        </Collapsible>

                    ) : children}
                </>
            )}
        </Box>
    );
}

export default Card;
